import { styled } from "@mui/material";

const StyledDiv = styled("div")(({ theme, checked = false }) => {
    const primaryColor = JSON.parse(sessionStorage.getItem("vendorTheme"))
        ?.theme?.color_shades;

    return {
        background: checked ? primaryColor[700] : theme.palette.grey[500],
    };
});

export const Switch = ({
    label = "Switch",
    checked = false,
    onChange = null,
}) => {
    if (!onChange) {
        console.error(
            "YOU ARE USING SWITCH WITHOUT onChange EVENT\nThis is not intended behaviour for this Component!"
        );
    }

    return (
        <label className="inline-flex items-center me-5 cursor-pointer">
            <input
                type="checkbox"
                name={`switch-${label}`}
                className="peer"
                style={{
                    display: "none",
                }}
                {...(!!onChange && {
                    onChange: onChange,
                    defaultValue: checked,
                    checked: checked,
                })}
            />

            <StyledDiv
                checked={checked}
                className="relative w-11 h-6 rounded-full peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all"
            />
            <span className="ms-1 text-sm font-medium text-black">{label}</span>
        </label>
    );
};
